import { useCallback, useEffect, useRef, useState } from 'react'

export default (initialValue = null, {
  validator = () => null,
} = {}) => {
  const ref = useRef()
  const [state, setState] = useState(initialValue)
  const [error, setError] = useState(null)
  const focus = useCallback(() => ref && ref.current && ref.current.focus && ref.current.focus(), [])
  const blur = useCallback(() => ref && ref.current && ref.current.blur && ref.current.blur(), [])
  const make = useCallback((fn, state) => () => fn(state), [])
  const chain = useCallback((...callables) => () => {
    !!callables && !!callables.length && callables.map(callable => callable())
  }, [])
  useEffect(() => {
    setError(validator(state))
  }, [state, validator])
  return {
    ref,
    focus,
    blur,
    state,
    setState,
    error,
    setError,
    make,
    chain,
  }
}


// WEBPACK FOOTER //
// ./src/hooks/useStateObject.js